// import './sentry';
import { loadTypers } from './typer';
import { loadNavs } from './nav';
import { loadCodeCopies } from './codeCopy';
import { loadSearches } from './search';
import { loadDropdowns } from './dropdown';
import { loadForms } from './form';
import { loadResponsivePositions } from './responsivePosition';
import { loadSwitchers } from './switcher';
import '@dantoo/dantools-frontend/client/js/utils/adaptive-config';

loadTypers(document.querySelectorAll('.typer'));
loadNavs(document.querySelectorAll('.nav'));
loadCodeCopies();
loadSearches();
loadDropdowns();
loadForms();
loadResponsivePositions();
loadSwitchers();
